// The one query cache. It is cleared whenever the session changes, so one
// account's conversations never show, even briefly, after another signs in.
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
})
